import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-6ae0fcde")

_pushScopeId("data-v-6ae0fcde")
const _hoisted_1 = { class: "property-nav" }
const _hoisted_2 = { class: "flex1" }
const _hoisted_3 = { class: "children" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_svg_icon = _resolveComponent("svg-icon")

  return (_openBlock(), _createBlock("ul", _hoisted_1, [
    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.menus, (item, index) => {
      return (_openBlock(), _createBlock("div", {
        key: item.name
      }, [
        (item.children)
          ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
              _createVNode("li", {
                title: item.label,
                onClick: ($event: any) => (_ctx.showSubMenu[index]=!_ctx.showSubMenu[index]),
                class: "display-flex subMenu"
              }, [
                (item.name.includes('userAgreement'))
                  ? (_openBlock(), _createBlock(_component_svg_icon, {
                      key: 0,
                      name: "icon-user-agreement",
                      class: "svg-class",
                      fontSize: "20px"
                    }))
                  : _createCommentVNode("", true),
                _createVNode("i", {
                  class: item.icon
                }, null, 2),
                _createVNode("label", _hoisted_2, _toDisplayString(item.label), 1),
                _createVNode("i", {
                  class: _ctx.showSubMenu[index]?'el-icon-arrow-down up':'el-icon-arrow-down down'
                }, null, 2)
              ], 8, ["title", "onClick"]),
              _withDirectives(_createVNode("div", _hoisted_3, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(item.children, (child) => {
                  return (_openBlock(), _createBlock("li", {
                    onClick: ($event: any) => (_ctx.changeRouter(child.path, child.type)),
                    key: child.name,
                    class: child.name.split('|').includes(_ctx.activeName) ? 'active' : '',
                    title: child.label
                  }, [
                    _createVNode("i", {
                      class: child.icon
                    }, null, 2),
                    _createTextVNode(" " + _toDisplayString(child.label), 1)
                  ], 10, ["onClick", "title"]))
                }), 128))
              ], 512), [
                [_vShow, _ctx.showSubMenu[index]]
              ])
            ], 64))
          : (_openBlock(), _createBlock("li", {
              key: 1,
              onClick: ($event: any) => (_ctx.changeRouter(item.path, item.type)),
              class: item.name.split('|').includes(_ctx.activeName) ? 'active' : '',
              title: item.label
            }, [
              _createVNode("i", {
                class: item.icon
              }, null, 2),
              _createTextVNode(" " + _toDisplayString(item.label), 1)
            ], 10, ["onClick", "title"]))
      ]))
    }), 128))
  ]))
})